import CircularProgress from '@mui/material/CircularProgress';
import CustomTheme from '../CustomTheme'

const CircleLoader = props => (<CustomTheme>
    <CircularProgress {...props} 
        color="primary"
        size={44}
    />
    </CustomTheme>)

export {CircleLoader}